import { Component, OnInit, ViewChild, ElementRef, Input, ViewChildren, EventEmitter, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs';
import { AuctionLotService } from 'src/app/services';

import { AuctionLotModel, PagedResult } from '../../../models';
import { } from '../../../shared/modals';

@Component({
    selector: 'auction-search-pagination',
    styleUrls: ['./auction-search-pagination.component.scss'],
    templateUrl: './auction-search-pagination.component.html',
    host: { 'class': 'd-flex justify-content-between' },
})
export class AuctionSearchPaginationComponent implements OnInit {
    
    @Input() model: PagedResult<AuctionLotModel>;

    @Output() setPage = new EventEmitter<number>();

    constructor(public router: Router, private activatedRoute: ActivatedRoute, public auctionLotService: AuctionLotService) {
        var me = this;
    }

    ngOnInit() {
        var me = this;
    }

    SetPage(page: number) {
        if (page <= 0)
            page = 1;
        if (page > this.model.PageCount)
            page = this.model.PageCount;
        if (!Number.isInteger(page))
            page = Number.parseInt(page.toString());
        this.setPage.emit(page);
    }
}
